import React from 'react';
import Navbar from './global-components/navbar';
import SliderV2 from './section-components/slider-v2';
import Features from './section-components/features';
import SoftBoxManage from './section-components/soft-box-manage';
import Screenshot from './section-components/screenshot';
import Subscribe from './section-components/subscribe';
import FooterV2 from './global-components/footer-v2';
import Contact_Form from './section-components/contact-form';

const Home_V2 = () => {
    return <div>
        <Navbar />
        <SliderV2 />
        <Features />
        <SoftBoxManage />
        <Screenshot />
        <Subscribe />
        <Contact_Form/>
        <FooterV2 />
    </div>
}

export default Home_V2

